import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface GetContractDocumentSourceRequest {
    dataRequestProjectId: number;
    dataTableId: number;
    fileColumnId: number;
    tableRowId: number;
    fileId: number;
}

export const GetContractDocumentSource = createAsyncThunk(
    'flowOfFunds/getContractDocumentSource',
    async (params: GetContractDocumentSourceRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/DataRequestProjects/${params.dataRequestProjectId}/dataTables/${params.dataTableId}/cells/${params.fileColumnId}/${params.tableRowId}/files/${params.fileId}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch the document link');
            }

            return response.data as string;
        } catch (error) {
            createNotification('Could not open the document.', 'error');
            throw error;
        }
    }
);
